/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { SessionEventDto } from './session-event-dto';
 /**
 *
 *
 * @export
 * @interface SessionEventPaginatedResponseDto
 */
export interface SessionEventPaginatedResponseDto {

    /**
     * @type {Array<SessionEventDto>}
     * @memberof SessionEventPaginatedResponseDto
     */
    data: Array<SessionEventDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof SessionEventPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
